module.exports = __webpack_public_path__ + "static/media/background.909f613c.png";